// import React, { useEffect, useRef, useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import ImageWithBasePath from "../imageWithBasePath";
// import { all_routes } from "../../../feature-module/router/all_routes";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   setExpandMenu,
//   setMiniSidebar,
//   setMobileSidebar,
// } from "../../data/redux/commonSlice";
// import LinkusDialer from "../linkus/LinkusDialer";
// import { useAppSelector } from "../../data/redux/hooks";
// import { setPhone } from "../../data/redux/slices/appCommonSlice";
// import { resetProfile } from "../../data/redux/slices/ProfileSlice";
// import api from "../../axios/axiosInstance";
// import FloatingDialer from "../floating-dialer/FloatingDialer";
// import {
//   closeDialer,
//   openDialer,
// } from "../../data/redux/slices/FloatingDialerSlice";
// import { clearContactsCache } from "../../data/redux/slices/ContactSlice";
// import { clearContactsCache as clearLeadsCache } from "../../data/redux/slices/LeadSlice";
// import { useDebounce } from "../../hooks/useDebounce";
// import { receiveMessage, updateMessageStatus } from "../../data/redux/slices/WabaChatSlice";
// import { fetchWabaTemplates } from "../../data/redux/slices/WabaTemplateSlice";
// import { Typography } from "antd";

// const Header = () => {
//   const route = all_routes;
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const userProfile = useSelector((state) => state.profile);
//   const mobileSidebar = useSelector((state) => state.common.mobileSidebar);
//   const miniSidebar = useSelector((state) => state.common.miniSidebar);
//   const [openDropdown, setOpenDropdown] = useState(false);
//   const [clientPhoneNumber, setClientPhoneNumber] = useState("");
//   const [credits, setCredits] = useState(0);
//   const [loadingCredits, setLoadingCredits] = useState(false);
//   const phoneNumber = useAppSelector((state) => state.appCommon.phone);

//   const { isOpen } = useSelector((state) => state.floatingDialer);

//   // Phone search states
//   const [searchPhone, setSearchPhone] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [isSearching, setIsSearching] = useState(false);
//   const [showSearchResults, setShowSearchResults] = useState(false);
//   const debouncedSearchPhone = useDebounce(searchPhone, 500);
//   const searchRef = useRef(null);
//   const { Title, Text } = Typography;
//   useEffect(() => {

//     if (userProfile?.accounts?.whatsapp?.isConnected) {

//       dispatch(fetchWabaTemplates())
//     }
//   }, [])
//   useEffect(() => {
//     setClientPhoneNumber(phoneNumber);
//     phoneNumber && showDropdown();
//   }, [phoneNumber]);

//   useEffect(() => {
//     console.log(userProfile, "khgfdghjkl");

//     if (userProfile?.extensionStatus) {
//       const fetchCalls = async () => {
//         try {
//           const response = await api.post("call/fetch-and-store");
//           console.log("Fetch calls response:", response.data);
//         } catch (error) {
//         }
//       };
//       fetchCalls();
//     }
//   }, []);

//   const userInfo = {
//     name:
//       userProfile.firstname && userProfile.lastname
//         ? `${userProfile.firstname} ${userProfile.lastname}`
//         : userProfile.email || "User",
//     firstname: userProfile.firstname || "",
//     lastname: userProfile.lastname || "",
//     email: userProfile.email || "",
//     avatar: userProfile.profileImageURL || null,
//     yeastarExtensionId: userProfile.yeastarExtensionId,
//     extensionNumber: userProfile.extensionNumber,
//     role: userProfile.role || "User",
//   };




//   useEffect(() => {
//     let ws;

//     const connectWebSocket = () => {
//       const token = localStorage.getItem("token");
//       ws = new WebSocket(
//         `wss://o6iyrho5q6.execute-api.eu-north-1.amazonaws.com/production?token=${token}`
//       );

//       ws.onopen = () => {
//         console.log("WebSocket connected");
//       };

//       ws.onmessage = (event) => {
//         if (!event.data) return;
//         console.log(event, "kjhgvcxgvhjbkn");


//         try {
//           const data = JSON.parse(event.data);

//           if (data.type === "whatsapp_message" && data.message) {
//             console.log(data.message, "data.message in header");
//             dispatch(receiveMessage(data.message));
//           }
//           if (data.type === "message_status_update" && data.message) {
//             console.log(data.message, "message_status_update in header");
//             dispatch(updateMessageStatus({
//               conversationId: data.message.conversationId,
//               metaMessageId: data.message.metaMessageId,
//               status: data.message.status
//             }));

//           }
//         } catch (err) {
//           console.warn("Received non-JSON message, ignoring:", event.data);
//         }
//       };


//       ws.onclose = () => {
//         console.log("WebSocket disconnected, reconnecting in 3s...");
//         setTimeout(connectWebSocket, 3000); // reconnect after 3 seconds
//       };

//       ws.onerror = (err) => {
//         console.error("WebSocket error", err);
//         ws.close(); // trigger onclose to reconnect
//       };
//     };

//     connectWebSocket(); // start the first connection

//     return () => {
//       if (ws) ws.close(); // cleanup when component unmounts
//     };
//   }, [dispatch]);









//   // Fetch credits on component mount
//   useEffect(() => {
//     fetchCredits();
//   }, [userProfile.id]);

//   // Handle phone search with debouncing
//   useEffect(() => {
//     if (debouncedSearchPhone.trim()) {
//       handlePhoneSearch(debouncedSearchPhone);
//     } else {
//       setSearchResults([]);
//       setShowSearchResults(false);
//     }
//   }, [debouncedSearchPhone]);

//   // Close search dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (searchRef.current && !searchRef.current.contains(event.target)) {
//         setShowSearchResults(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const fetchCredits = async () => {
//     if (!userProfile.id) return;

//     setLoadingCredits(true);
//     try {
//       // Dummy API call to fetch credits
//       const response = await api.get(`/credits/${userProfile.id}`);
//       setCredits(response.data.credits || 0);
//     } catch (error) {
//       console.error("Error fetching credits:", error);
//       // Set dummy credits for fallback
//       setCredits(1250);
//     } finally {
//       setLoadingCredits(false);
//     }
//   };

//   const handleRecharge = () => {
//     navigate("/");
//   };
//   const handlePhoneSearch = async (phone) => {
//     setIsSearching(true);
//     try {
//       const response = await api.get(
//         `/getAllContactsOrLeads/searchByPhone?phone=${encodeURIComponent(
//           phone
//         )}`
//       );
//       if (response.data.status === "success") {
//         setSearchResults(response.data.results || []);
//         setShowSearchResults(true);
//       }
//     } catch (error) {
//       console.error("Phone search error:", error);
//       setSearchResults([]);
//     } finally {
//       setIsSearching(false);
//     }
//   };

//   const handleClearSearch = () => {
//     if (!searchPhone) return;
//     setSearchPhone("");
//     setSearchResults([]);
//     setShowSearchResults(false);
//   };

//   const getOwnerDisplay = (result) => {
//     const isCurrentUser = result.ownerId === userProfile.id;
//     if (isCurrentUser) {
//       return "You";
//     }
//     const roleLabel = result.ownerRole === "user" ? " (Agent)" : "";
//     return `${result.ownerName}${roleLabel} (${result.ownerEmail})`;
//   };

//   const toggleDropdown = () => {
//     setOpenDropdown(!openDropdown);

//     dispatch(setPhone(""));
//   };
//   const showDropdown = () => {
//     setOpenDropdown(true);
//   };

//   const toggleMobileSidebar = () => {
//     dispatch(setMobileSidebar(!mobileSidebar));
//   };
//   const toggleMiniSidebar = () => {
//     dispatch(setMiniSidebar(!miniSidebar));
//   };
//   const toggleExpandMenu = () => {
//     dispatch(setExpandMenu(true));
//   };
//   const toggleExpandMenu2 = () => {
//     dispatch(setExpandMenu(false));
//   };

//   const handleLogout = async () => {
//     try {
//       // Clear all localStorage data
//       localStorage.removeItem("userId");
//       localStorage.removeItem("token");

//       // Reset Redux state
//       // dispatch(resetProfile());

//       // // Navigate to login
//       // dispatch(clearContactsCache());
//       // dispatch(clearLeadsCache());
//       window.location.href = "/";

//     } catch (error) {
//       console.error("❌ Logout error:", error);

//       // Still proceed with logout even if there's an error
//       localStorage.removeItem("userId");
//       localStorage.removeItem("token");
//       dispatch(resetProfile());
//       window.location.href = "/";
//     }
//   };

//   const [layoutBs, setLayoutBs] = useState(localStorage.getItem("dataTheme"));
//   const isLockScreen = location.pathname === "/lock-screen";

//   if (isLockScreen) {
//     return null;
//   }
//   const LayoutDark = () => {
//     localStorage.setItem("dataTheme", "dark");
//     document.documentElement.setAttribute("data-theme", "dark");
//     setLayoutBs("dark");
//   };
//   const LayoutLight = () => {
//     localStorage.setItem("dataTheme", "light");
//     document.documentElement.setAttribute("data-theme", "light");
//     setLayoutBs("light");
//   };

//   return (
//     <>
//       <div className="header" style={{ zIndex: 1000 }}>
//         <div className="header-left active">
//           <Link to={route.agentDashboard} className="logo logo-normal">
//             <ImageWithBasePath src="assets/img/voycell-logo.webp" alt="Logo" />
//             <ImageWithBasePath
//               src="assets/img/white-logo.svg"
//               className="white-logo"
//               alt="Logo"
//             />
//           </Link>
//           <Link to={route.agentDashboard} className="logo-small">
//             <ImageWithBasePath src="assets/img/favicon.ico" alt="Logo" />
//           </Link>
//         </div>
//         <Link
//           id="mobile_btn"
//           className="mobile_btn"
//           to="#sidebar"
//           onClick={toggleMobileSidebar}
//         >
//           <span className="bar-icon">
//             <span />
//             <span />
//             <span />
//           </span>
//         </Link>
//         <div className="header-user">
//           <ul className="nav user-menu">

//             <li className="nav-item nav-search-inputs me-auto">








//               {/* <Text className="welcome-text" ellipsis>
//                   Welcome back,{" "}
//                   {userInfo.firstname || userInfo.name}!
//                 </Text> */}

//               <Text className="welcome-text">
//                 Welcome back,{" "}
//                 {(userInfo.firstname || userInfo.name).length > 30
//                   ? `${(userInfo.firstname || userInfo.name).slice(0, 30)}…`
//                   : userInfo.firstname || userInfo.name}!
//               </Text>


















//             </li>
//             <li className="nav-item nav-search-inputs me-auto">
//               <div className="d-flex gap-5 align-items-center">


//                 <Text
//                   type="secondary"
//                   className="user-detail-text"
//                 >
//                   Extension:{" "}
//                   <span className="fw-bold text-purple">
//                     {userInfo.extensionNumber || "Not Assigned"}
//                   </span>
//                 </Text>
//                 <Text
//                   type="secondary"
//                   className="user-detail-text"
//                 >
//                   Number:{" "}
//                   <span className="fw-bold text-purple">
//                     {userProfile.telephone
//                       ? "+" + userProfile.telephone
//                       : "Not Assigned"}
//                   </span>
//                 </Text>
//                 <Text
//                   type="secondary"
//                   className="user-detail-text"
//                 >
//                   Extension Status:{" "}
//                   <span
//                     className={`status-dot ${userProfile.extensionStatus ? "live" : "offline"
//                       }`}
//                   ></span>
//                 </Text>

//                 <Text
//                   type="secondary"
//                   className="user-detail-text"
//                 >
//                   Account Status:{" "}
//                   <span
//                     className={`status-dot ${userProfile.accountStatus ? "live" : "offline"
//                       }`}
//                   ></span>
//                 </Text>
//               </div>
//             </li>

//             <li
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 alignItems: "center",
//                 gap: "10px",
//                 flexWrap: "nowrap",
//                 justifyContent:"space-between",
//                 width:"100%"
//               }}
//             >
//               <div className="nav-item nav-search-inputs ms-auto">
//                 <div className="top-nav-search" ref={searchRef}>
//                   <Link to="#" className="responsive-search">
//                     <i className="fa fa-search" />
//                   </Link>
//                   <div className="dropdown" style={{ position: "relative" }}>
//                     <div className="searchinputs" id="dropdownMenuClickable">
//                       <input
//                         type="text"
//                         placeholder="Search by phone number"
//                         value={searchPhone}
//                         onChange={(e) => setSearchPhone(e.target.value)}
//                         onFocus={() =>
//                           searchResults.length > 0 && setShowSearchResults(true)
//                         }
//                       />
//                       <div
//                         className="search-addon"
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "4px",
//                         }}
//                       >
//                         {
//                           <button
//                             type="button"
//                             onClick={handleClearSearch}
//                             style={{
//                               background: "transparent",
//                               border: "none",
//                               cursor: "pointer",
//                               padding: "0",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                             }}
//                           >
//                             {isSearching ? (
//                               <i className="fa fa-spinner fa-spin" />
//                             ) : searchPhone ? (
//                               <i className="ti ti-x" />
//                             ) : (
//                               <i className="ti ti-search" />
//                             )}
//                           </button>
//                         }
//                         {/* <button
//                                     type="button"
//                                     style={{
//                                       background: "transparent",
//                                       border: "none",
//                                       padding: "0",
//                                       display: "flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                     }}
//                                   >
//                                     {isSearching ? (
//                                       <i className="fa fa-spinner fa-spin" />
//                                     ) : (
//                                       <i className="ti ti-search" />
//                                     )}
//                                   </button> */}
//                       </div>
//                     </div>

//                     {/* Search Results Dropdown */}
//                     {showSearchResults && (
//                       <div
//                         style={{
//                           position: "absolute",
//                           top: "100%",
//                           left: 0,
//                           right: 0,
//                           backgroundColor: "white",
//                           border: "1px solid #e9ecef",
//                           borderRadius: "4px",
//                           boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
//                           maxHeight: "400px",
//                           overflowY: "auto",
//                           zIndex: 1000,
//                           marginTop: "4px",
//                         }}
//                       >
//                         {searchResults.length === 0 ? (
//                           <div
//                             style={{
//                               padding: "16px",
//                               textAlign: "center",
//                               color: "#6c757d",
//                             }}
//                           >
//                             No results found
//                           </div>
//                         ) : (
//                           searchResults.map((result, index) => (
//                             <div
//                               key={index}
//                               style={{
//                                 padding: "12px 16px",
//                                 borderBottom:
//                                   index < searchResults.length - 1
//                                     ? "1px solid #f0f0f0"
//                                     : "none",
//                                 cursor: "pointer",
//                                 transition: "background-color 0.2s",
//                               }}
//                               onMouseEnter={(e) =>
//                               (e.currentTarget.style.backgroundColor =
//                                 "#f8f9fa")
//                               }
//                               onMouseLeave={(e) =>
//                                 (e.currentTarget.style.backgroundColor = "white")
//                               }
//                             >
//                               <div
//                                 style={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   marginBottom: "4px",
//                                 }}
//                               >
//                                 <span
//                                   style={{
//                                     display: "inline-block",
//                                     padding: "2px 8px",
//                                     borderRadius: "4px",
//                                     fontSize: "11px",
//                                     fontWeight: "600",
//                                     marginRight: "8px",
//                                     backgroundColor:
//                                       result.type === "contact"
//                                         ? "#d1ecf1"
//                                         : "#fff3cd",
//                                     color:
//                                       result.type === "contact"
//                                         ? "#0c5460"
//                                         : "#856404",
//                                   }}
//                                 >
//                                   {result.type === "contact" ? "Contact" : "Lead"}
//                                 </span>
//                                 <strong style={{ fontSize: "14px" }}>
//                                   {result.firstname} {result.lastname}
//                                 </strong>
//                               </div>
//                               <div
//                                 style={{
//                                   fontSize: "13px",
//                                   color: "#495057",
//                                   marginBottom: "4px",
//                                 }}
//                               >
//                                 {result.phoneNumbers?.map((phone, idx) => (
//                                   <div key={idx}>
//                                     +{phone.countryCode} {phone.number}
//                                   </div>
//                                 ))}
//                               </div>
//                               <div
//                                 style={{
//                                   fontSize: "12px",
//                                   color: "#6c757d",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: "6px",
//                                   flexWrap: "wrap",
//                                 }}
//                               >
//                                 <span>Owner:</span>
//                                 {result.ownerId === userProfile.id ? (
//                                   <span style={{ fontWeight: "500" }}>You</span>
//                                 ) : (
//                                   <>
//                                     <span style={{ fontWeight: "500" }}>
//                                       {result.ownerName}
//                                     </span>
//                                     {result.ownerRole === "user" ? (
//                                       <span
//                                         style={{
//                                           display: "inline-block",
//                                           padding: "2px 6px",
//                                           borderRadius: "3px",
//                                           fontSize: "10px",
//                                           fontWeight: "600",
//                                           backgroundColor: "#e7f3ff",
//                                           color: "#0066cc",
//                                         }}
//                                       >
//                                         Agent
//                                       </span>
//                                     ) : (
//                                       <span
//                                         style={{
//                                           display: "inline-block",
//                                           padding: "2px 6px",
//                                           borderRadius: "3px",
//                                           fontSize: "10px",
//                                           fontWeight: "600",
//                                           backgroundColor: "#fff4e5",
//                                           color: "orange",
//                                         }}
//                                       >
//                                         Company Admin
//                                       </span>
//                                     )}
//                                     <span style={{ color: "#999" }}>
//                                       ({result.ownerEmail})
//                                     </span>
//                                   </>
//                                 )}
//                               </div>
//                             </div>
//                           ))
//                         )}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>

//               <div className="d-flex align-items-center">
//               <div className="nav-item nav-list">
//                 <ul className="nav">
//                   <li className="nav-item">
//                     <div
//                       className="d-flex align-items-center bg-light rounded me-2"
//                       style={{
//                         border: "1px solid #e9ecef",
//                         boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//                         padding: "4px 12px",
//                         paddingRight: "4px",
//                         cursor: "pointer",
//                         justifyContent: "space-between",
//                       }}
//                     >
//                       <Link
//                         to="#"
//                         className="d-flex align-items-center"
//                         aria-expanded="false"
//                         onClick={() => {
//                           // toggleDropdown();
//                           if (isOpen) {
//                             dispatch(closeDialer());
//                           } else {
//                             dispatch(openDialer());
//                           }
//                         }}
//                       >
//                         {/* <i className="typcn typcn-phone me-2" /> */}
//                         <span className="me-2 text-primary">Dialer</span>
//                         <button className="ms-2 d-flex justify-content-center align-items-center rounded bg-primary">
//                           <i
//                             className="ti ti-phone text-white my-1"
//                             style={{ fontSize: "16px" }}
//                           ></i>
//                         </button>
//                       </Link>
//                       {isOpen && (
//                         <i
//                           className="ti ti-chevron-up text-muted"
//                           style={{ fontSize: "14px" }}
//                         ></i>
//                       )}
//                       <FloatingDialer />
//                     </div>
//                   </li>
//                 </ul>
//               </div>

//               <div className="nav-item dropdown has-arrow main-drop">
//                 <Link
//                   to={route.agentProfile}
//                   className="nav-link userset me-2 p-0"
//                 // data-bs-toggle="dropdown"
//                 >
//                   <span className="user-info">
//                     <span className="user-letter">
//                       {userProfile.profileImageURL ? (
//                         <img
//                           src={userProfile.profileImageURL}
//                           alt="Profile"
//                           style={{ objectFit: "cover", height: "100%" }}
//                         />
//                       ) : (
//                         <ImageWithBasePath
//                           src="assets/img/profiles/avatar-20.jpg"
//                           alt="Profile"
//                         />
//                       )}
//                     </span>
//                     <span className="badge badge-success rounded-pill" />
//                   </span>
//                 </Link>
//               </div>


//               <div>
//                 <Link
//                   // className="dropdown-item"
//                   to="#"
//                   data-bs-toggle="modal"
//                   data-bs-target="#logoutModal"
//                 >
//                   <ImageWithBasePath
//                     src="assets/img/icons/logout.png"
//                     alt="Logout"
//                     width={15}
//                     className="me-3"
//                   />
//                 </Link>
//               </div>
//             </div>
//             </li>
//           </ul>


//         </div>
//         {/* Mobile Menu */}
//         <div className="dropdown mobile-user-menu">
//           <Link
//             to="#"
//             className="nav-link dropdown-toggle"
//             data-bs-toggle="dropdown"
//             aria-expanded="false"
//           >
//             <i className="fa fa-ellipsis-v" />
//           </Link>
//           <div className={` dropdown-menu `}>
//             <Link className="dropdown-item" to={route.agentDashboard}>
//               <i className="ti ti-layout-2" /> Dashboard
//             </Link>
//             <Link className="dropdown-item" to={route.agentProfile}>
//               <i className="ti ti-user-pin" /> My Profile
//             </Link>
//             <Link
//               className="dropdown-item"
//               to="#"
//               data-bs-toggle="modal"
//               data-bs-target="#logoutModal"
//             >
//               <i className="ti ti-lock" /> Logout
//             </Link>
//           </div>
//         </div>
//         {/* /Mobile Menu */}
//       </div>

//       {/* Logout Modal */}
//       <div
//         className="modal fade"
//         id="logoutModal"
//         tabIndex="-1"
//         aria-labelledby="logout"
//         role="dialog"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-body">
//               <div className="text-center">
//                 <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
//                   <i className="fa-solid fa-right-from-bracket fs-36 text-danger" />
//                 </div>
//                 <h4 className="mb-2 text-capitalize">Logout?</h4>
//                 <p className="mb-0">
//                   Are you sure you want to logout from your account?
//                 </p>
//                 <div className="d-flex align-items-center justify-content-center mt-4">
//                   <Link
//                     to="#"
//                     className="btn btn-light me-2"
//                     data-bs-dismiss="modal"
//                   >
//                     Cancel
//                   </Link>
//                   <Link
//                     to={"#"}
//                     data-bs-dismiss="modal"
//                     className="btn btn-danger"
//                     onClick={() => {
//                       handleLogout();
//                     }}
//                   >
//                     Yes, Logout
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Header;














// import React, { useEffect, useRef, useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import ImageWithBasePath from "../imageWithBasePath";
// import { all_routes } from "../../../feature-module/router/all_routes";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   setExpandMenu,
//   setMiniSidebar,
//   setMobileSidebar,
// } from "../../data/redux/commonSlice";
// import LinkusDialer from "../linkus/LinkusDialer";
// import { useAppSelector } from "../../data/redux/hooks";
// import { setPhone } from "../../data/redux/slices/appCommonSlice";
// import { resetProfile } from "../../data/redux/slices/ProfileSlice";
// import api from "../../axios/axiosInstance";
// import FloatingDialer from "../floating-dialer/FloatingDialer";
// import {
//   closeDialer,
//   openDialer,
// } from "../../data/redux/slices/FloatingDialerSlice";
// import { clearContactsCache } from "../../data/redux/slices/ContactSlice";
// import { clearContactsCache as clearLeadsCache } from "../../data/redux/slices/LeadSlice";
// import { useDebounce } from "../../hooks/useDebounce";
// import { receiveMessage, updateMessageStatus } from "../../data/redux/slices/WabaChatSlice";
// import { fetchWabaTemplates } from "../../data/redux/slices/WabaTemplateSlice";
// import { Typography } from "antd";

// const Header = () => {
//   const route = all_routes;
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const userProfile = useSelector((state) => state.profile);
//   const mobileSidebar = useSelector((state) => state.common.mobileSidebar);
//   const miniSidebar = useSelector((state) => state.common.miniSidebar);
//   const [openDropdown, setOpenDropdown] = useState(false);
//   const [clientPhoneNumber, setClientPhoneNumber] = useState("");
//   const [credits, setCredits] = useState(0);
//   const [loadingCredits, setLoadingCredits] = useState(false);
//   const phoneNumber = useAppSelector((state) => state.appCommon.phone);

//   const { isOpen } = useSelector((state) => state.floatingDialer);

//   // Phone search states
//   const [searchPhone, setSearchPhone] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [isSearching, setIsSearching] = useState(false);
//   const [showSearchResults, setShowSearchResults] = useState(false);
//   const debouncedSearchPhone = useDebounce(searchPhone, 500);
//   const searchRef = useRef(null);
//   const { Title, Text } = Typography;
//   useEffect(() => {

//     if (userProfile?.accounts?.whatsapp?.isConnected) {

//       dispatch(fetchWabaTemplates())
//     }
//   }, [])
//   useEffect(() => {
//     setClientPhoneNumber(phoneNumber);
//     phoneNumber && showDropdown();
//   }, [phoneNumber]);

//   useEffect(() => {
//     console.log(userProfile, "khgfdghjkl");

//     if (userProfile?.extensionStatus) {
//       const fetchCalls = async () => {
//         try {
//           const response = await api.post("call/fetch-and-store");
//           console.log("Fetch calls response:", response.data);
//         } catch (error) {
//         }
//       };
//       fetchCalls();
//     }
//   }, []);

//   const userInfo = {
//     name:
//       userProfile.firstname && userProfile.lastname
//         ? `${userProfile.firstname} ${userProfile.lastname}`
//         : userProfile.email || "User",
//     firstname: userProfile.firstname || "",
//     lastname: userProfile.lastname || "",
//     email: userProfile.email || "",
//     avatar: userProfile.profileImageURL || null,
//     yeastarExtensionId: userProfile.yeastarExtensionId,
//     extensionNumber: userProfile.extensionNumber,
//     role: userProfile.role || "User",
//   };




//   useEffect(() => {
//     let ws;

//     const connectWebSocket = () => {
//       const token = localStorage.getItem("token");
//       ws = new WebSocket(
//         `wss://o6iyrho5q6.execute-api.eu-north-1.amazonaws.com/production?token=${token}`
//       );

//       ws.onopen = () => {
//         console.log("WebSocket connected");
//       };

//       ws.onmessage = (event) => {
//         if (!event.data) return;
//         console.log(event, "kjhgvcxgvhjbkn");


//         try {
//           const data = JSON.parse(event.data);

//           if (data.type === "whatsapp_message" && data.message) {
//             console.log(data.message, "data.message in header");
//             dispatch(receiveMessage(data.message));
//           }
//           if (data.type === "message_status_update" && data.message) {
//             console.log(data.message, "message_status_update in header");
//             dispatch(updateMessageStatus({
//               conversationId: data.message.conversationId,
//               metaMessageId: data.message.metaMessageId,
//               status: data.message.status
//             }));

//           }
//         } catch (err) {
//           console.warn("Received non-JSON message, ignoring:", event.data);
//         }
//       };


//       ws.onclose = () => {
//         console.log("WebSocket disconnected, reconnecting in 3s...");
//         setTimeout(connectWebSocket, 3000); // reconnect after 3 seconds
//       };

//       ws.onerror = (err) => {
//         console.error("WebSocket error", err);
//         ws.close(); // trigger onclose to reconnect
//       };
//     };

//     connectWebSocket(); // start the first connection

//     return () => {
//       if (ws) ws.close(); // cleanup when component unmounts
//     };
//   }, [dispatch]);


//   // Fetch credits on component mount
//   useEffect(() => {
//     fetchCredits();
//   }, [userProfile.id]);

//   // Handle phone search with debouncing
//   useEffect(() => {
//     if (debouncedSearchPhone.trim()) {
//       handlePhoneSearch(debouncedSearchPhone);
//     } else {
//       setSearchResults([]);
//       setShowSearchResults(false);
//     }
//   }, [debouncedSearchPhone]);

//   // Close search dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (searchRef.current && !searchRef.current.contains(event.target)) {
//         setShowSearchResults(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const fetchCredits = async () => {
//     if (!userProfile.id) return;

//     setLoadingCredits(true);
//     try {
//       // Dummy API call to fetch credits
//       const response = await api.get(`/credits/${userProfile.id}`);
//       setCredits(response.data.credits || 0);
//     } catch (error) {
//       console.error("Error fetching credits:", error);
//       // Set dummy credits for fallback
//       setCredits(1250);
//     } finally {
//       setLoadingCredits(false);
//     }
//   };

//   const handleRecharge = () => {
//     navigate("/");
//   };
//   const handlePhoneSearch = async (phone) => {
//     setIsSearching(true);
//     try {
//       const response = await api.get(
//         `/getAllContactsOrLeads/searchByPhone?phone=${encodeURIComponent(
//           phone
//         )}`
//       );
//       if (response.data.status === "success") {
//         setSearchResults(response.data.results || []);
//         setShowSearchResults(true);
//       }
//     } catch (error) {
//       console.error("Phone search error:", error);
//       setSearchResults([]);
//     } finally {
//       setIsSearching(false);
//     }
//   };

//   const handleClearSearch = () => {
//     if (!searchPhone) return;
//     setSearchPhone("");
//     setSearchResults([]);
//     setShowSearchResults(false);
//   };

//   const getOwnerDisplay = (result) => {
//     const isCurrentUser = result.ownerId === userProfile.id;
//     if (isCurrentUser) {
//       return "You";
//     }
//     const roleLabel = result.ownerRole === "user" ? " (Agent)" : "";
//     return `${result.ownerName}${roleLabel} (${result.ownerEmail})`;
//   };

//   const toggleDropdown = () => {
//     setOpenDropdown(!openDropdown);

//     dispatch(setPhone(""));
//   };
//   const showDropdown = () => {
//     setOpenDropdown(true);
//   };

//   const toggleMobileSidebar = () => {
//     dispatch(setMobileSidebar(!mobileSidebar));
//   };
//   const toggleMiniSidebar = () => {
//     dispatch(setMiniSidebar(!miniSidebar));
//   };
//   const toggleExpandMenu = () => {
//     dispatch(setExpandMenu(true));
//   };
//   const toggleExpandMenu2 = () => {
//     dispatch(setExpandMenu(false));
//   };

//   const handleLogout = async () => {
//     try {
//       // Clear all localStorage data
//       localStorage.removeItem("userId");
//       localStorage.removeItem("token");

//       // Reset Redux state
//       // dispatch(resetProfile());

//       // // Navigate to login
//       // dispatch(clearContactsCache());
//       // dispatch(clearLeadsCache());
//       window.location.href = "/";

//     } catch (error) {
//       console.error("❌ Logout error:", error);

//       // Still proceed with logout even if there's an error
//       localStorage.removeItem("userId");
//       localStorage.removeItem("token");
//       dispatch(resetProfile());
//       window.location.href = "/";
//     }
//   };

//   const [layoutBs, setLayoutBs] = useState(localStorage.getItem("dataTheme"));
//   const isLockScreen = location.pathname === "/lock-screen";

//   if (isLockScreen) {
//     return null;
//   }
//   const LayoutDark = () => {
//     localStorage.setItem("dataTheme", "dark");
//     document.documentElement.setAttribute("data-theme", "dark");
//     setLayoutBs("dark");
//   };
//   const LayoutLight = () => {
//     localStorage.setItem("dataTheme", "light");
//     document.documentElement.setAttribute("data-theme", "light");
//     setLayoutBs("light");
//   };

//   return (
//     <>
//       <div className="header" style={{ zIndex: 1000 }}>
//         <div className="header-left active">
//           <Link to={route.agentDashboard} className="logo logo-normal">
//             <ImageWithBasePath src="assets/img/voycell-logo.webp" alt="Logo" />
//             <ImageWithBasePath
//               src="assets/img/white-logo.svg"
//               className="white-logo"
//               alt="Logo"
//             />
//           </Link>
//           <Link to={route.agentDashboard} className="logo-small">
//             <ImageWithBasePath src="assets/img/favicon.ico" alt="Logo" />
//           </Link>
//         </div>
//         <Link
//           id="mobile_btn"
//           className="mobile_btn"
//           to="#sidebar"
//           onClick={toggleMobileSidebar}
//         >
//           <span className="bar-icon">
//             <span />
//             <span />
//             <span />
//           </span>
//         </Link>
//         <div className="header-user">
//           <ul
//             className="nav user-menu justify-content-end"
//             style={{ flexWrap: "wrap", alignItems: "center" }}
//           >

//             {/* Welcome text — hard-left, never grows/shrinks */}
//             <li
//               className="nav-item nav-search-inputs me-auto"
//               style={{ flexGrow: 0, flexShrink: 0, width: "auto" }}
//             >
//               <Text className="welcome-text">
//                 Welcome back,{" "}
//                 {(userInfo.firstname || userInfo.name).length > 30
//                   ? `${(userInfo.firstname || userInfo.name).slice(0, 30)}…`
//                   : userInfo.firstname || userInfo.name}!
//               </Text>
//             </li>

//             {/* Extension / Number / Status — takes remaining row-1 space, spreads evenly */}
//             <li
//               className="nav-item nav-search-inputs me-auto"
//               style={{ flex: 1, minWidth: 0 }}
//             >
//               <div
//                 className="d-flex align-items-center"
//                 style={{ justifyContent: "space-evenly", width: "100%", gap: "8px" }}
//               >
//                 <Text
//                   type="secondary"
//                   className="user-detail-text"
//                   style={{ whiteSpace: "nowrap" }}
//                 >
//                   Extension:{" "}
//                   <span className="fw-bold text-purple">
//                     {userInfo.extensionNumber || "Not Assigned"}
//                   </span>
//                 </Text>
//                 <Text
//                   type="secondary"
//                   className="user-detail-text"
//                   style={{ whiteSpace: "nowrap" }}
//                 >
//                   Number:{" "}
//                   <span className="fw-bold text-purple">
//                     {userProfile.telephone
//                       ? "+" + userProfile.telephone
//                       : "Not Assigned"}
//                   </span>
//                 </Text>
//                 <Text
//                   type="secondary"
//                   className="user-detail-text"
//                   style={{ whiteSpace: "nowrap" }}
//                 >
//                   Extension Status:{" "}
//                   <span
//                     className={`status-dot ${userProfile.extensionStatus ? "live" : "offline"
//                       }`}
//                   ></span>
//                 </Text>
//                 <Text
//                   type="secondary"
//                   className="user-detail-text"
//                   style={{ whiteSpace: "nowrap" }}
//                 >
//                   Account Status:{" "}
//                   <span
//                     className={`status-dot ${userProfile.accountStatus ? "live" : "offline"
//                       }`}
//                   ></span>
//                 </Text>
//               </div>
//             </li>

//             {/* Zero-height row-break forces search+actions onto their own row */}
//             <li
//               aria-hidden="true"
//               style={{ flexBasis: "100%", height: 0, padding: 0, margin: 0, listStyle: "none" }}
//             />

//             {/* Search — left side of row 2, grows to fill available space */}
//             <li
//               className="nav-item nav-search-inputs me-auto"
//               style={{ flex: 1, minWidth: 0 }}
//             >
//               <div className="top-nav-search" ref={searchRef}>
//                 <Link to="#" className="responsive-search">
//                   <i className="fa fa-search" />
//                 </Link>
//                 <div className="dropdown" style={{ position: "relative" }}>
//                   <div className="searchinputs" id="dropdownMenuClickable">
//                     <input
//                       type="text"
//                       placeholder="Search by phone number"
//                       value={searchPhone}
//                       onChange={(e) => setSearchPhone(e.target.value)}
//                       onFocus={() =>
//                         searchResults.length > 0 && setShowSearchResults(true)
//                       }
//                     />
//                     <div
//                       className="search-addon"
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "4px",
//                       }}
//                     >
//                       {
//                         <button
//                           type="button"
//                           onClick={handleClearSearch}
//                           style={{
//                             background: "transparent",
//                             border: "none",
//                             cursor: "pointer",
//                             padding: "0",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                           }}
//                         >
//                           {isSearching ? (
//                             <i className="fa fa-spinner fa-spin" />
//                           ) : searchPhone ? (
//                             <i className="ti ti-x" />
//                           ) : (
//                             <i className="ti ti-search" />
//                           )}
//                         </button>
//                       }
//                     </div>
//                   </div>

//                   {/* Search Results Dropdown */}
//                   {showSearchResults && (
//                     <div
//                       style={{
//                         position: "absolute",
//                         top: "100%",
//                         left: 0,
//                         right: 0,
//                         backgroundColor: "white",
//                         border: "1px solid #e9ecef",
//                         borderRadius: "4px",
//                         boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
//                         maxHeight: "400px",
//                         overflowY: "auto",
//                         zIndex: 1000,
//                         marginTop: "4px",
//                       }}
//                     >
//                       {searchResults.length === 0 ? (
//                         <div
//                           style={{
//                             padding: "16px",
//                             textAlign: "center",
//                             color: "#6c757d",
//                           }}
//                         >
//                           No results found
//                         </div>
//                       ) : (
//                         searchResults.map((result, index) => (
//                           <div
//                             key={index}
//                             style={{
//                               padding: "12px 16px",
//                               borderBottom:
//                                 index < searchResults.length - 1
//                                   ? "1px solid #f0f0f0"
//                                   : "none",
//                               cursor: "pointer",
//                               transition: "background-color 0.2s",
//                             }}
//                             onMouseEnter={(e) =>
//                             (e.currentTarget.style.backgroundColor =
//                               "#f8f9fa")
//                             }
//                             onMouseLeave={(e) =>
//                               (e.currentTarget.style.backgroundColor = "white")
//                             }
//                           >
//                             <div
//                               style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 marginBottom: "4px",
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   display: "inline-block",
//                                   padding: "2px 8px",
//                                   borderRadius: "4px",
//                                   fontSize: "11px",
//                                   fontWeight: "600",
//                                   marginRight: "8px",
//                                   backgroundColor:
//                                     result.type === "contact"
//                                       ? "#d1ecf1"
//                                       : "#fff3cd",
//                                   color:
//                                     result.type === "contact"
//                                       ? "#0c5460"
//                                       : "#856404",
//                                 }}
//                               >
//                                 {result.type === "contact" ? "Contact" : "Lead"}
//                               </span>
//                               <strong style={{ fontSize: "14px" }}>
//                                 {result.firstname} {result.lastname}
//                               </strong>
//                             </div>
//                             <div
//                               style={{
//                                 fontSize: "13px",
//                                 color: "#495057",
//                                 marginBottom: "4px",
//                               }}
//                             >
//                               {result.phoneNumbers?.map((phone, idx) => (
//                                 <div key={idx}>
//                                   +{phone.countryCode} {phone.number}
//                                 </div>
//                               ))}
//                             </div>
//                             <div
//                               style={{
//                                 fontSize: "12px",
//                                 color: "#6c757d",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: "6px",
//                                 flexWrap: "wrap",
//                               }}
//                             >
//                               <span>Owner:</span>
//                               {result.ownerId === userProfile.id ? (
//                                 <span style={{ fontWeight: "500" }}>You</span>
//                               ) : (
//                                 <>
//                                   <span style={{ fontWeight: "500" }}>
//                                     {result.ownerName}
//                                   </span>
//                                   {result.ownerRole === "user" ? (
//                                     <span
//                                       style={{
//                                         display: "inline-block",
//                                         padding: "2px 6px",
//                                         borderRadius: "3px",
//                                         fontSize: "10px",
//                                         fontWeight: "600",
//                                         backgroundColor: "#e7f3ff",
//                                         color: "#0066cc",
//                                       }}
//                                     >
//                                       Agent
//                                     </span>
//                                   ) : (
//                                     <span
//                                       style={{
//                                         display: "inline-block",
//                                         padding: "2px 6px",
//                                         borderRadius: "3px",
//                                         fontSize: "10px",
//                                         fontWeight: "600",
//                                         backgroundColor: "#fff4e5",
//                                         color: "orange",
//                                       }}
//                                     >
//                                       Company Admin
//                                     </span>
//                                   )}
//                                   <span style={{ color: "#999" }}>
//                                     ({result.ownerEmail})
//                                   </span>
//                                 </>
//                               )}
//                             </div>
//                           </div>
//                         ))
//                       )}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </li>

//             {/* Dialer + Profile + Logout — right side of row 2 */}
//             <li
//               style={{
//                 display: "flex",
//                 flexDirection: "row",
//                 alignItems: "center",
//                 gap: "10px",
//                 flexWrap: "nowrap",
//                 marginLeft: "auto",
//               }}
//             >
//               {/* Nav List */}
//               <div className="nav-item nav-list">
//                 <ul className="nav">
//                   <li className="nav-item">
//                     <div
//                       className="d-flex align-items-center bg-light rounded me-2"
//                       style={{
//                         border: "1px solid #e9ecef",
//                         boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//                         padding: "4px 12px",
//                         paddingRight: "4px",
//                         cursor: "pointer",
//                         justifyContent: "space-between",
//                       }}
//                     >
//                       <Link
//                         to="#"
//                         className="d-flex align-items-center"
//                         aria-expanded="false"
//                         onClick={() => {
//                           // toggleDropdown();
//                           if (isOpen) {
//                             dispatch(closeDialer());
//                           } else {
//                             dispatch(openDialer());
//                           }
//                         }}
//                       >
//                         {/* <i className="typcn typcn-phone me-2" /> */}
//                         <span className="me-2 text-primary">Dialer</span>
//                         <button className="ms-2 d-flex justify-content-center align-items-center rounded bg-primary">
//                           <i
//                             className="ti ti-phone text-white my-1"
//                             style={{ fontSize: "16px" }}
//                           ></i>
//                         </button>
//                       </Link>
//                       {isOpen && (
//                         <i
//                           className="ti ti-chevron-up text-muted"
//                           style={{ fontSize: "14px" }}
//                         ></i>
//                       )}
//                       <FloatingDialer />
//                     </div>
//                   </li>
//                 </ul>
//               </div>
//               {/* Profile Dropdown */}
//               <div className="nav-item dropdown has-arrow main-drop">
//                 <Link
//                   to={route.agentProfile}
//                   className="nav-link userset me-2 p-0"
//                 // data-bs-toggle="dropdown"
//                 >
//                   <span className="user-info">
//                     <span className="user-letter">
//                       {userProfile.profileImageURL ? (
//                         <img
//                           src={userProfile.profileImageURL}
//                           alt="Profile"
//                           style={{ objectFit: "cover", height: "100%" }}
//                         />
//                       ) : (
//                         <ImageWithBasePath
//                           src="assets/img/profiles/avatar-20.jpg"
//                           alt="Profile"
//                         />
//                       )}
//                     </span>
//                     <span className="badge badge-success rounded-pill" />
//                   </span>
//                 </Link>
//               </div>
//               <div>
//                 <Link
//                   // className="dropdown-item"
//                   to="#"
//                   data-bs-toggle="modal"
//                   data-bs-target="#logoutModal"
//                 >
//                   <ImageWithBasePath
//                     src="assets/img/icons/logout.png"
//                     alt="Logout"
//                     width={15}
//                     className="me-3"
//                   />
//                 </Link>
//               </div>
//             </li>
//           </ul>
//         </div>
//         {/* Mobile Menu */}
//         <div className="dropdown mobile-user-menu">
//           <Link
//             to="#"
//             className="nav-link dropdown-toggle"
//             data-bs-toggle="dropdown"
//             aria-expanded="false"
//           >
//             <i className="fa fa-ellipsis-v" />
//           </Link>
//           <div className={` dropdown-menu `}>
//             <Link className="dropdown-item" to={route.agentDashboard}>
//               <i className="ti ti-layout-2" /> Dashboard
//             </Link>
//             <Link className="dropdown-item" to={route.agentProfile}>
//               <i className="ti ti-user-pin" /> My Profile
//             </Link>
//             <Link
//               className="dropdown-item"
//               to="#"
//               data-bs-toggle="modal"
//               data-bs-target="#logoutModal"
//             >
//               <i className="ti ti-lock" /> Logout
//             </Link>
//           </div>
//         </div>
//         {/* /Mobile Menu */}
//       </div>

//       {/* Logout Modal */}
//       <div
//         className="modal fade"
//         id="logoutModal"
//         tabIndex="-1"
//         aria-labelledby="logout"
//         role="dialog"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-body">
//               <div className="text-center">
//                 <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
//                   <i className="fa-solid fa-right-from-bracket fs-36 text-danger" />
//                 </div>
//                 <h4 className="mb-2 text-capitalize">Logout?</h4>
//                 <p className="mb-0">
//                   Are you sure you want to logout from your account?
//                 </p>
//                 <div className="d-flex align-items-center justify-content-center mt-4">
//                   <Link
//                     to="#"
//                     className="btn btn-light me-2"
//                     data-bs-dismiss="modal"
//                   >
//                     Cancel
//                   </Link>
//                   <Link
//                     to={"#"}
//                     data-bs-dismiss="modal"
//                     className="btn btn-danger"
//                     onClick={() => {
//                       handleLogout();
//                     }}
//                   >
//                     Yes, Logout
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Header;























import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../imageWithBasePath";
import { all_routes } from "../../../feature-module/router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import {
  setExpandMenu,
  setMiniSidebar,
  setMobileSidebar,
} from "../../data/redux/commonSlice";
import LinkusDialer from "../linkus/LinkusDialer";
import { useAppSelector } from "../../data/redux/hooks";
import { setPhone } from "../../data/redux/slices/appCommonSlice";
import { resetProfile } from "../../data/redux/slices/ProfileSlice";
import api from "../../axios/axiosInstance";
import FloatingDialer from "../floating-dialer/FloatingDialer";
import {
  closeDialer,
  openDialer,
} from "../../data/redux/slices/FloatingDialerSlice";
import { fetchCredits } from "../../data/redux/slices/CreditsSlice";
import { clearContactsCache } from "../../data/redux/slices/ContactSlice";
import { clearContactsCache as clearLeadsCache } from "../../data/redux/slices/LeadSlice";
import { useDebounce } from "../../hooks/useDebounce";
import { receiveMessage, updateMessageStatus } from "../../data/redux/slices/WabaChatSlice";
import { fetchWabaTemplates } from "../../data/redux/slices/WabaTemplateSlice";
import { Typography } from "antd";
import AvatarInitialStyles from "../nameInitialStyles/AvatarInitialStyles";
import NotificationDropdown from "../notifications/NotificationDropdown";

const Header = () => {
  const route = all_routes;
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userProfile = useSelector((state) => state.profile);
  const mobileSidebar = useSelector((state) => state.common.mobileSidebar);
  const miniSidebar = useSelector((state) => state.common.miniSidebar);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [clientPhoneNumber, setClientPhoneNumber] = useState("");
  const credits        = useSelector((state) => state.credits.balance);
  const loadingCredits = useSelector((state) => state.credits.loading);
  const phoneNumber = useAppSelector((state) => state.appCommon.phone);

  const { isOpen } = useSelector((state) => state.floatingDialer);

  const [searchPhone, setSearchPhone] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const debouncedSearchPhone = useDebounce(searchPhone, 500);
  const searchRef = useRef(null);
  const { Title, Text } = Typography;

  useEffect(() => {
    if (userProfile?.accounts?.whatsapp?.isConnected) {
      dispatch(fetchWabaTemplates());
    }
  }, []);

  useEffect(() => {
    setClientPhoneNumber(phoneNumber);
    phoneNumber && showDropdown();
  }, [phoneNumber]);

  useEffect(() => {
    if (userProfile?.extensionStatus) {
      const fetchCalls = async () => {
        try {
          const response = await api.post("call/fetch-and-store");
        } catch (error) { }
      };
      fetchCalls();
    }
  }, []);

  const userInfo = {
    name:
      userProfile.firstname && userProfile.lastname
        ? `${userProfile.firstname} ${userProfile.lastname}`
        : userProfile.email || "User",
    firstname: userProfile.firstname || "",
    lastname: userProfile.lastname || "",
    email: userProfile.email || "",
    avatar: userProfile.profileImageURL || null,
    yeastarExtensionId: userProfile.yeastarExtensionId,
    extensionNumber: userProfile.extensionNumber,
    role: userProfile.role || "User",
  };

  useEffect(() => {
    let ws;
    const connectWebSocket = () => {
      const token = localStorage.getItem("token");
      ws = new WebSocket(
        `wss://o6iyrho5q6.execute-api.eu-north-1.amazonaws.com/production?token=${token}`
      );
      ws.onopen = () => console.log("WebSocket connected");
      ws.onmessage = (event) => {
        if (!event.data) return;
        try {
          const data = JSON.parse(event.data);
          if (data.type === "whatsapp_message" && data.message) {
            dispatch(receiveMessage(data.message));
          }
          if (data.type === "message_status_update" && data.message) {
            dispatch(updateMessageStatus({
              conversationId: data.message.conversationId,
              metaMessageId: data.message.metaMessageId,
              status: data.message.status,
            }));
          }
        } catch (err) {
          console.warn("Received non-JSON message, ignoring:", event.data);
        }
      };
      ws.onclose = () => {
        console.log("WebSocket disconnected, reconnecting in 3s...");
        setTimeout(connectWebSocket, 3000);
      };
      ws.onerror = (err) => {
        console.error("WebSocket error", err);
        ws.close();
      };
    };
    connectWebSocket();
    return () => { if (ws) ws.close(); };
  }, [dispatch]);

  useEffect(() => {
    if (userProfile.id) dispatch(fetchCredits());
  }, [userProfile.id]);

  useEffect(() => {
    if (debouncedSearchPhone.trim()) {
      handlePhoneSearch(debouncedSearchPhone);
    } else {
      setSearchResults([]);
      setShowSearchResults(false);
    }
  }, [debouncedSearchPhone]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearchResults(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const handleRecharge = () => navigate("/");

  const handlePhoneSearch = async (phone) => {
    setIsSearching(true);
    try {
      const response = await api.get(
        `/getAllContactsOrLeads/searchByPhone?phone=${encodeURIComponent(phone)}`
      );
      if (response.data.status === "success") {
        setSearchResults(response.data.results || []);
        setShowSearchResults(true);
      }
    } catch (error) {
      setSearchResults([]);
    } finally {
      setIsSearching(false);
    }
  };

  const handleClearSearch = () => {
    if (!searchPhone) return;
    setSearchPhone("");
    setSearchResults([]);
    setShowSearchResults(false);
  };

  const toggleDropdown = () => {
    setOpenDropdown(!openDropdown);
    dispatch(setPhone(""));
  };
  const showDropdown = () => setOpenDropdown(true);
  const toggleMobileSidebar = () => dispatch(setMobileSidebar(!mobileSidebar));
  const toggleMiniSidebar = () => dispatch(setMiniSidebar(!miniSidebar));
  const toggleExpandMenu = () => dispatch(setExpandMenu(true));
  const toggleExpandMenu2 = () => dispatch(setExpandMenu(false));

  const handleLogout = async () => {
    try {
      localStorage.removeItem("userId");
      localStorage.removeItem("token");
      window.location.href = "/";
    } catch (error) {
      localStorage.removeItem("userId");
      localStorage.removeItem("token");
      dispatch(resetProfile());
      window.location.href = "/";
    }
  };

  const [layoutBs, setLayoutBs] = useState(localStorage.getItem("dataTheme"));
  const isLockScreen = location.pathname === "/lock-screen";
  if (isLockScreen) return null;

  const LayoutDark = () => {
    localStorage.setItem("dataTheme", "dark");
    document.documentElement.setAttribute("data-theme", "dark");
    setLayoutBs("dark");
  };
  const LayoutLight = () => {
    localStorage.setItem("dataTheme", "light");
    document.documentElement.setAttribute("data-theme", "light");
    setLayoutBs("light");
  };

  return (
    <>
      <div className="header" style={{ zIndex: 1000 }}>
        <div className="header-left active">
          <Link to={route.agentDashboard} className="logo logo-normal">
            <ImageWithBasePath src="assets/img/voycell-logo.webp" alt="Logo" />
            <ImageWithBasePath src="assets/img/white-logo.svg" className="white-logo" alt="Logo" />
          </Link>
          <Link to={route.agentDashboard} className="logo-small">
            <ImageWithBasePath src="assets/img/favicon.ico" alt="Logo" />
          </Link>
        </div>
        <Link id="mobile_btn" className="mobile_btn" to="#sidebar" onClick={toggleMobileSidebar}>
          <span className="bar-icon">
            <span /><span /><span />
          </span>
        </Link>

        <div className="header-user">
          
          <ul className="nav user-menu justify-content-end">
         
            <li
              className="nav-item nav-search-inputs"
              style={{ display: "flex", alignItems: "center" }}
            >
              <Text className="welcome-text">
                Welcome back,{" "}
                {(userInfo.firstname || userInfo.name).length > 30
                  ? `${(userInfo.firstname || userInfo.name).slice(0, 30)}…`
                  : userInfo.firstname || userInfo.name}!
              </Text>
            </li>

            <li
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "10px",
                flexWrap: "nowrap",
                marginLeft: "auto",       /* right-align when on its own row */
                alignSelf: "center",
              }}
            >
              {/* Search */}
              <div className="nav-item nav-search-inputs">
                <div className="top-nav-search" ref={searchRef}>
                  <Link to="#" className="responsive-search">
                    <i className="fa fa-search" />
                  </Link>
                  <div className="dropdown" style={{ position: "relative" }}>
                    <div className="searchinputs" id="dropdownMenuClickable">
                      <input
                        type="text"
                        placeholder="Search by phone number"
                        value={searchPhone}
                        onChange={(e) => setSearchPhone(e.target.value)}
                        onFocus={() => searchResults.length > 0 && setShowSearchResults(true)}
                      />
                      <div className="search-addon" style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <button
                          type="button"
                          onClick={handleClearSearch}
                          style={{ background: "transparent", border: "none", cursor: "pointer", padding: "0", display: "flex", alignItems: "center", justifyContent: "center" }}
                        >
                          {isSearching ? (
                            <i className="fa fa-spinner fa-spin" />
                          ) : searchPhone ? (
                            <i className="ti ti-x" />
                          ) : (
                            <i className="ti ti-search" />
                          )}
                        </button>
                      </div>
                    </div>

                    {showSearchResults && (
                      <div style={{ position: "absolute", top: "100%", left: 0, right: 0, backgroundColor: "white", border: "1px solid #e9ecef", borderRadius: "4px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)", maxHeight: "400px", overflowY: "auto", zIndex: 1000, marginTop: "4px" }}>
                        {searchResults.length === 0 ? (
                          <div style={{ padding: "16px", textAlign: "center", color: "#6c757d" }}>No results found</div>
                        ) : (
                          searchResults.map((result, index) => (
                            <div
                              key={index}
                              style={{ padding: "12px 16px", borderBottom: index < searchResults.length - 1 ? "1px solid #f0f0f0" : "none", cursor: "pointer", transition: "background-color 0.2s" }}
                              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f8f9fa")}
                              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "white")}
                            >
                              <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                                <span style={{ display: "inline-block", padding: "2px 8px", borderRadius: "4px", fontSize: "11px", fontWeight: "600", marginRight: "8px", backgroundColor: result.type === "contact" ? "#d1ecf1" : "#fff3cd", color: result.type === "contact" ? "#0c5460" : "#856404" }}>
                                  {result.type === "contact" ? "Contact" : "Lead"}
                                </span>
                                <strong style={{ fontSize: "14px" }}>{result.firstname} {result.lastname}</strong>
                              </div>
                              <div style={{ fontSize: "13px", color: "#495057", marginBottom: "4px" }}>
                                {result.phoneNumbers?.map((phone, idx) => (
                                  <div key={idx}>+{phone.countryCode} {phone.number}</div>
                                ))}
                              </div>
                              <div style={{ fontSize: "12px", color: "#6c757d", display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                                <span>Owner:</span>
                                {result.ownerId === userProfile.id ? (
                                  <span style={{ fontWeight: "500" }}>You</span>
                                ) : (
                                  <>
                                    <span style={{ fontWeight: "500" }}>{result.ownerName}</span>
                                    {result.ownerRole === "user" ? (
                                      <span style={{ display: "inline-block", padding: "2px 6px", borderRadius: "3px", fontSize: "10px", fontWeight: "600", backgroundColor: "#e7f3ff", color: "#0066cc" }}>Agent</span>
                                    ) : (
                                      <span style={{ display: "inline-block", padding: "2px 6px", borderRadius: "3px", fontSize: "10px", fontWeight: "600", backgroundColor: "#fff4e5", color: "orange" }}>Company Admin</span>
                                    )}
                                    <span style={{ color: "#999" }}>({result.ownerEmail})</span>
                                  </>
                                )}
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* ── Credit balance chip ── */}
              <div className="nav-item me-1">
                <div
                  className="d-flex align-items-center bg-light rounded"
                  style={{
                    border: "1px solid #e9ecef",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    padding: "4px 4px 4px 12px",
                    gap: 8,
                  }}
                >
                  <span style={{ fontSize: 11, color: "#9ca3af", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                    Balance
                  </span>
                  <span style={{ fontSize: 14, fontWeight: 800, color: "#3C2371" }}>
                    {loadingCredits ? "…" : `$${Number(credits).toFixed(2)}`}
                  </span>
                  <button
                    onClick={fetchCredits}
                    title="Refresh Balance"
                    disabled={loadingCredits}
                    style={{
                      width: 28, height: 28, borderRadius: "50%",
                      background: "transparent", border: "1px solid #d1d5db",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      cursor: "pointer", flexShrink: 0,
                    }}
                  >
                    <i className={`ti ti-refresh${loadingCredits ? " fa-spin" : ""}`} style={{ fontSize: 13, color: "#6b7280" }} />
                  </button>
                </div>
              </div>

              {/* Dialer */}
              <div className="nav-item nav-list">
                <ul className="nav">
                  <li className="nav-item">
                    <div
                      className="d-flex align-items-center bg-light rounded me-2"
                      style={{ border: "1px solid #e9ecef", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", padding: "4px 12px", paddingRight: "4px", cursor: "pointer", justifyContent: "space-between" }}
                    >
                      <Link
                        to="#"
                        className="d-flex align-items-center"
                        aria-expanded="false"
                        onClick={() => { if (isOpen) { dispatch(closeDialer()); } else { dispatch(openDialer()); } }}
                      >
                        <span className="me-2 text-primary">Dialer</span>
                        <button className="ms-2 d-flex justify-content-center align-items-center rounded bg-primary">
                          <i className="ti ti-phone text-white my-1" style={{ fontSize: "16px" }} />
                        </button>
                      </Link>
                      {isOpen && <i className="ti ti-chevron-up text-muted" style={{ fontSize: "14px" }} />}
                    </div>
                  </li>
                </ul>
              </div>

              {/* Notifications */}
              <div className="nav-item" style={{ display: "flex", alignItems: "center" }}>
                <NotificationDropdown />
              </div>

              {/* Profile */}
              <div className="nav-item dropdown has-arrow main-drop">
                <Link to={route.agentProfile} className="nav-link userset me-2 p-0">
                  <span className="user-info">
                    <span className="user-letter">
                      {userProfile.profileImageURL ? (
                        <img src={userProfile.profileImageURL} alt="Profile" style={{ objectFit: "contain", height: "100%" }} />
                      ) : (
                        // <ImageWithBasePath src="assets/img/profiles/avatar-20.jpg" alt="Profile" />
                         <AvatarInitialStyles
                                name={`${userProfile.firstname} ${userProfile.lastname}`}
                                divStyles={{ width:40, height:40, borderRadius:8 }}
                              />
                      )}
                    </span>
                    <span className="badge badge-success rounded-pill" />
                  </span>
                </Link>
              </div>

              {/* Logout */}
              {/* <div>
                <Link to="#" data-bs-toggle="modal" data-bs-target="#logoutModal">
                  <ImageWithBasePath src="assets/img/icons/logout.png" alt="Logout" width={15} className="me-3" />
                </Link>
              </div> */}
            </li>
          </ul>
        </div>

        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link to="#" className="nav-link dropdown-toggle border-0" style={{boxShadow:"none"}} data-bs-toggle="dropdown" aria-expanded="false">
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu">
            {/* <Link className="dropdown-item" to={route.agentDashboard}><i className="ti ti-layout-2" /> Dashboard</Link> */}
            <Link className="dropdown-item" to={route.agentProfile}><i className="ti ti-user-pin" /> My Profile</Link>
            <Link className="dropdown-item" to="#" data-bs-toggle="modal" data-bs-target="#logoutModal"><i className="ti ti-lock" /> Logout</Link>
          </div>
        </div>
      </div>
      <FloatingDialer />

      {/* Logout Modal */}
      <div className="modal fade" id="logoutModal" tabIndex="-1" aria-labelledby="logout" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-theme-light rounded-circle mb-3">
                  <i className="fa-solid fa-right-from-bracket fs-36 text-theme" />
                </div>
                <h4 className="mb-2 text-capitalize">Logout?</h4>
                <p className="mb-0">Are you sure you want to logout from your account?</p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link to="#" className="btn btn-light me-2" data-bs-dismiss="modal">Cancel</Link>
                  <Link to={"#"} data-bs-dismiss="modal" className="btn btn-theme text-white" onClick={handleLogout}>Yes, Logout</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
